import colors from "./colors";
import radius from "./radius.json";

export const visiblescroll = {
  visiblescroll: `
  // Supported by Edge, Chrome, Safari, Opera: https://caniuse.com/?search=%3A%3A-webkit-scrollbar
  &::-webkit-scrollbar {
    width: 0.75rem;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px ${colors.ColorWhite};
    border: solid 3px transparent;
    border-radius: ${radius.RadiusXL};
  }
  &::-webkit-scrollbar-thumb {
    border-radius: ${radius.RadiusXL};
    box-shadow: inset 0 0 10px 10px ${colors.ColorSpace100};
    border: solid 3px transparent;
  }

  // Supported by Firefox only: https://caniuse.com/?search=scrollbar-color
  scrollbar-width: thin;
  scrollbar-color: ${colors.ColorSpace100} ${colors.ColorWhite};
`,
};
